import { render, staticRenderFns } from "./MediaVideo.vue?vue&type=template&id=01d55a28&scoped=true&"
import script from "./MediaVideo.vue?vue&type=script&lang=ts&"
export * from "./MediaVideo.vue?vue&type=script&lang=ts&"
import style0 from "./MediaVideo.vue?vue&type=style&index=0&id=01d55a28&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d55a28",
  null
  
)

export default component.exports